import React, { useState, useEffect } from 'react';
import { getEventClassName } from '../../../../../LogEvents/helper';
import { getCurrentStateClassName } from '../../../../helpers/node';

function SessionIndicator(props) {
  let className;
  const {
 nodeHeight, nodeWidth, events, sliceEvent, chargerProps,
} = props;
  const [timeout, putTimeout] = useState();

  if (events.length) {
    className = getEventClassName(events[0], chargerProps, getCurrentStateClassName);

    if (!timeout) {
      putTimeout(
        setTimeout(() => {
          sliceEvent();
          putTimeout(null);
        }, 2000),
      );
    }
  } else {
    className = getCurrentStateClassName(chargerProps);
  }

  useEffect(() => () => clearTimeout(timeout), [timeout]);

  return (
    <foreignObject y={nodeHeight - 12} x={nodeWidth / 2 - 14} width={26} height={24}>
      <div className={className} />
    </foreignObject>
  );
}

export default SessionIndicator;
